import { last, first } from "lodash";
import { useParameter, useDictionaryItem, yearToCropYearShort } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";

export function useSlideSubtitle() {
  const [commodities] = useParameter<number[]>("@commodities_display");
  const [commodityItem] = useDictionaryItem(dictionaryService, "slides-commodities-display", Number(last(commodities)), {
    business_unit: 1,
    slide: 26,
  });

  const [parameterValues] = useParameter<number[]>("@calendar");
  const [, calendarName] = useDictionaryItem(dictionaryService, "calendar-population", parameterValues ? parameterValues[2] : null);
  const year = calendarName ? Number(calendarName) : new Date().getFullYear() - 1;
  const usdaSubtitle = `USDA marketing year (eg. ${yearToCropYearShort(year)} = Crop Year ${yearToCropYearShort(year - 1)})`;
  const comment = commodityItem?.getValue<string | null>("comment");
  const subtitle = !comment && comment !== "" ? usdaSubtitle : comment;

  return subtitle;
}
